/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '../../mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.licenseMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.license = res.data.data;
    }
  },
  [storeMutations.setLicenseMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.licenses = res.data;
    }
  },
  [storeMutations.setLicenseCount]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.licenseCount = res.data.total;
    }
  },
  [storeMutations.setCustomerInfo]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.customers= res.data;

    }
  },
  [storeMutations.setCustomerProfileByIdInfo]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.customer= res.data;
    }
  },
};
export default { ...mutations };
